export const THANK_YOU = 'Thanks for your feedback!';
export const SUBMIT_TEXT = 'Send';
export const FEEDBACK_INPUT_PLACEHOLDER =
  'How does this make you feel? Please leave 20 words or more';
